import { __ } from '@wordpress/i18n';
// @ts-ignore
const { registerPaymentMethod } = window.wc.wcBlocksRegistry;
import { PAYMENT_METHOD_NAME } from './contants';
import './style.scss';
import { Options, PaymentFields } from '../../../../../../src/interfaces/WoocommercePaymentBlockSupport';
import { decodeEntities } from '@wordpress/html-entities';
import Content from './Components/Content';
import Label from './Components/Label';

// @ts-ignore
const settings: PaymentFields = wc.wcSettings.getSetting(`${PAYMENT_METHOD_NAME}_data`);
const label = settings?.title ?? decodeEntities( __( 'MangoPay', 'dokan' ) );

const canMakePayment = (  ) => {
    return true;
};



const options: Options = {
    name: PAYMENT_METHOD_NAME,
    label: <Label label={label} settings={settings}/>,
    content: <Content settings={settings}/>,
    edit: <Content settings={settings}/>,
    canMakePayment,
    ariaLabel: label,
    supports: {}
};

registerPaymentMethod( options );
